<template>
  <section class="survey-section">
    <div class="pb-4 d-flex align-center">
      <img class="mb-2 survey-section__icon" v-if="icon && icon.length > 0" :src="icon">
      <div :class="icon && icon.length > 0 ? 'pl-4' : ''">
        <h1 :class="`${isTheRiseFrameworkSurvey ? 'mainColor--text' : ''} mb-2`">{{ title }}</h1>
        <p class="mb-2" v-if="description && description.length > 0"><strong>{{ description }}</strong></p>
      </div>
    </div>
    <div class="survey-section__questions" v-if="questions && questions.length > 0">
      <survey-question
        v-for="question in questions"
        :key="`question-${question.id}`"
        :id="question.id"
        :title="question.title"
        :description="question.description"
        :answers="question.answers"
        :type="question.type"
        :required.sync="question.required"
        :disabled-answers="disabledAnswers"
        :disabled-questions.sync="disabledQuestions"
        :show-input-required-error.sync="showInputRequiredError"
        @handleChangeAnswer="handleChangeAnswer"
        :is-the-rise-framework-survey="isTheRiseFrameworkSurvey"
        />
    </div>
  </section>
</template>

<script>
import { SURVEY_ANSWER_TYPES, SURVEY_QUESTION_TYPES } from '@/helpers/constants'
import SurveyQuestion from '@/components/survey/SurveyQuestion.vue'

export default {
  name: 'SurveySection',
  components: {
    SurveyQuestion
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    completed: {
      type: Boolean,
      default: false
    },
    questions: {
      type: Array,
      default: () => []
    },
    icon: {
      type: String,
      default: '',
    },
    disabledAnswers: {
      type: Boolean,
      default: false,
    },
    disabledQuestions: {
      type: Array,
      default: () => [],
    },
    showInputRequiredError: {
      type: Boolean,
      default: false,
    },
    isTheRiseFrameworkSurvey: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      SURVEY_QUESTION_TYPES,
      SURVEY_ANSWER_TYPES
    }
  },
  computed: {
  },
  methods: {
    handleChangeAnswer({question, answer, data, parentAnswerId, parentQuestionId, rootParentAnswerId, rootParentQuestionId, allAnswersData}) {
      this.$emit('handleChangeAnswer', {
        question,
        answer,
        data,
        parentAnswerId,
        parentQuestionId,
        rootParentAnswerId,
        rootParentQuestionId,
        allAnswersData,
      })
    }
  },
}
</script>

<style lang="scss">
@import '@/styles/variables';

.survey-section {
  counter-reset: question-counter;

  &__icon {
    max-width: 64px;
  }
}
</style>
